module.exports = __webpack_public_path__ + "static/media/Faster Than My Dreams.5f1c3a32.jpg";